import { getCustomAudiences, getCustomAudiencesExclusion } from './helpers'

import {
  CUSTOM_AUDIENCES,
  CUSTOM_AUDIENCES_EXCLUSION
} from '../../../../../ReusableFormFields/Audiences/AudiencesFields/fields'

export const getInitialValues = (targeting, audiences) => {
  return {
    [CUSTOM_AUDIENCES]: getCustomAudiences(targeting, audiences),
    [CUSTOM_AUDIENCES_EXCLUSION]: getCustomAudiencesExclusion(targeting, audiences)
  }
}
